// extracted by mini-css-extract-plugin
export default {"header":"InGameBlock_header__-ItXs","text":"InGameBlock_text__RwiqX","wrapper":"InGameBlock_wrapper__zWWQd","results":"InGameBlock_results__TlGWw"};